<template>
  <transition name="bounce">
    <div class="main_bg" :class="{'hidden': !visible}">
      <i :class="[typ]">{{message}}</i>
      <i class="icon-tuichu" @click="closeToast">X</i>
    </div>
  </transition>
</template>
<script>
  export default {
    props:{
      message: {type:String,default:'提示消息'},
      visible: {type: Boolean, default: true},
      duration:{type:Number,default:2000},
      type:{type:String,default:''}
    },
    data () {
      return {
        typ:''
      }
    },
    watch:{
      type(data){
        console.log(data);
        this.typ = this.type;
      }
    },
    methods:{
      closeToast: function () {
        this.close();
      }
    },
  }
</script>
<style scoped >
  .SUCCESS{color:chartreuse;}
  .WARING{color:orangered}
  .main_bg{
    position: fixed;
    left: 50%;
    transform: translate(-50%);
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 10px;
    min-width: 400px;
    text-align:center;
    background: #fff;
  }

  .icon-tuichu{
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
  }
  .hidden {
    transform: scale(0);
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/message.vue